import { Color } from '@bb/elements-web-rebranding';
import { Icon } from '@brokerbay/elements-web';
import { Text } from 'components';
import React from 'react';
import styled from 'styled-components';

type CardStatusType = 'error' | 'info';

const CARD_STATUS_STYLES: Record<
  CardStatusType,
  {
    color: string;
    background: string;
    border: string;
    icon: Pick<Parameters<typeof Icon>[0], 'icon' | 'color'>;
  }
> = {
  error: {
    color: Color.DODORIA,
    background: '#FFF2F0', // TODO: convert to constant
    border: '#FFCCC7', // TODO: convert to constant
    icon: { icon: 'closeFilled', color: 'danger' },
  },
  info: {
    color: Color.ROSHI,
    background: '#E6F3FF', // TODO: convert to constant
    border: '#91C3FF', // TODO: convert to constant
    icon: { icon: 'infoCircleFilled', color: 'primary' },
  },
};

const CardStatusContainer = styled.div<{ status: CardStatusType }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  color: ${props => CARD_STATUS_STYLES[props.status].color};
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
  border-color: ${props => CARD_STATUS_STYLES[props.status].border};
  background-color: ${props => CARD_STATUS_STYLES[props.status].background};
`;

export const CardStatus = ({
  status,
  text,
  ...props
}: {
  status: CardStatusType;
  text: string;
}) => {
  if (!text) return null;
  const {
    icon: { icon, color },
  } = CARD_STATUS_STYLES[status];
  return (
    <CardStatusContainer {...props} status={status}>
      <Icon icon={icon} size={16} color={color} />
      <Text>{text}</Text>
    </CardStatusContainer>
  );
};
